RivalIQ.module('landscape.views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.CompanyAdd = RivalIQ.views.ItemView.extend({
        shouldFollow: true,
        ui: {
            companyAddButton: '.x-company-search',
            domainInput: '.x-domain-input',
            companyPreview: '.x-company-preview',
            domainContainer: '.x-domain-container'
        },
        events: {
            'keypress @ui.domainInput': 'onKeypress'
        },

        eventsNotToDebounce: {
            'click @ui.companyAddButton': 'onClick'
        },

        initialize: function (options) {
            const me = this;
            const opts = options || {};

            _.extend(me, _.pick(opts, 'createLandscape', 'shouldFollow'));

            me.listenTo(App, 'over-limit', _.bind(me.onOverLimit, me));
            me.listenTo(App, 'suggestion-selected', me.onSuggestionSelected);

            // this is defined here, inline, because I don't want to define an onRender() method
            // since this prototype gets extended and the caller may not call the parent method.
            // i could have made this callback a method on this object and just wired it here, but
            // this seems good enough.
            me.on('render', function () {

                me.typeahead = new views.CompanyAddTypeahead({
                    el: me.ui.domainInput
                });
            });

            me.listenTo(App, 'company-add-autocomplete', me.handleAutocomplete);
            me.listenTo(App, 'company-add-removed', me.onCompanyRemoved);

            // NOTE this is a little bit of a hack...
            // what happens here is that the typeahead fires this event when
            // it experiences an error, but only of the kind that we filter
            // out explicitly here (Facebook pages and invalid domains), so
            // if we just call our search method we will be sure to arrive at
            // the same error results, and get the appropriate rendering
            me.listenTo(App, 'company-add-error', me.search);
        },

        loadData: function () {
            return $.getJSON('/api/account/limits/companies').done(function (data) {
                RivalIQ.state.account.set({
                    landscapeCompanyLimits: data
                });
            });
        },

        handleAutocomplete: function (data) {

            const me = this;

            // if we haven't saved the landscape name yet, we need to before we can follow companies
            me.setDisabledState();

            if (me.createLandscape && !me.landscapeModel.id) {

                me.saveLandscape()
                    .done(function () {
                        me.doFollowAndShow(data, me.landscapeModel.id, true);
                    })
                    .fail(function () {
                        me.onError('Something went wrong. Please reload your page and try again.');
                    });
            } else {

                me.doFollowAndShow(data, (me.createLandscape ? me.landscapeModel.id : null), false);
            }
        },
        doFollow: function (id, landscapeId) {
            const options = {
                companyId: id
            };
            if (landscapeId) {
                options.landscapeId = landscapeId;
            }
            return RivalIQ.landscape.follow(options);
        },
        doFollowAndShow: function (searchData, landscapeId, disableUnfollow) {
            const me = this;
            const id = searchData.company_id;

            const model = _.extend(new RivalIQ.models.Company(), {
                searchData: searchData
            });

            // TODO we should not do this here as it requires a dance
            // to occur below in `done`...
            new views.CompanyAddResults({
                pubsub: App,
                model: model,
                disableUnfollow: disableUnfollow,
                el: me.ui.companyPreview,
                landscapeId: landscapeId
            }).render().clearAndShowLoading();

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.CompanyAddViaModal);

            return me.doFollow(id, landscapeId)
                .done(function (company) {
                    const data = company.toJSON();
                    // TODO this is the aforementioned dance
                    model.set(data);
                    me.onSearchSuccess(model, data);
                })
                .fail(function (xhr) {
                    me.onSearchFailed(model, xhr);
                });
        },
        setDisabledState: function () {
            const me = this;
            me.ui.companyAddButton.attr?.('disabled', true);
            me.ui.domainInput.attr?.('disabled', true);
        },
        clearDisabledState: function () {
            const me = this;
            me.ui.companyAddButton.removeAttr?.('disabled');
            me.ui.domainInput.removeAttr?.('disabled');
        },
        saveLandscape: function () {
            const me = this;

            const options = {
                timezone: RivalIQ.utils.timezone.getClientTimezoneString()
            };

            return me.landscapeModel.save(options)
                .done(function () {
                    me.triggerMethod('landscape:created');
                });
        },
        onKeypress: function (e) {

            const me = this;

            if (e.keyCode === 13) {

                me.search();
                e.preventDefault();
            }
        },
        onClick: function (e) {
            e.preventDefault();
            this.search();
        },
        search: function () {

            let model;
            const me = this;
            const input = me.ui.domainInput;
            const domain = $.trim(input.val());

            if (input.attr('disabled')) {
                return;
            }

            me.setDisabledState();

            // tell our typehead we have made a selection
            if (me.typeahead) {

                me.typeahead.selectionMade = true;
            }

            // NOTE if absolutely nothing was entered then fail without giving
            // any indication to the user; they should know not to be such
            // boneheads
            if (!domain) {

                me.clearDisabledState();
                return;
            }

            if (!domain.match(/\./)) {

                input.focus();
                new views.CompanyAddResults({
                    model: new Backbone.Model({
                        url: domain,
                        RESTerror: {
                            name: 'notDomain'
                        }
                    }),
                    pubsub: App,
                    el: me.ui.companyPreview
                }).render();
                me.clearDisabledState();
                return false;
            }

            // if we are creating a new landscape, don't follow if we don't have a landscape yet
            const shouldFollow = me.createLandscape && !me.landscapeModel.id ? false : me.shouldFollow;

            me.model = model = new RivalIQ.models.CompanyAdd({
                url: domain,
                follow: shouldFollow
            });

            const landscapeId = (_.get(me, 'landscapeModel.id') || RivalIQ.state.view.get('landscapeId'));
            model.setLandscapeId(landscapeId);

            if (me.onBeforeModelSearch(model) !== false) {
                me.onSearch(model);
            } else {
                me.clearDisabledState();
            }
        },
        onBeforeModelSearch: function (model) {
            const me = this;
            new views.CompanyAddResults({
                model: model,
                pubsub: App,
                disableUnfollow: !model.get('follow'),
                el: me.ui.companyPreview,
                landscapeId: (me.createLandscape && me.landscapeModel.id ? me.landscapeModel.id : null)
            }).render().clearAndShowLoading();
        },
        onSearch: function (model) {
            const me = this;

            // NOTE: when we are trying to add a company to a brand new
            // landscape we can't use the model, as the result view is already
            // listening to it. instead, we must make a clone of the model.
            let toSave = model;
            if (me.createLandscape && !me.landscapeModel.id) {
                toSave = _.extend(model.clone(), {
                    landscapeId: model.landscapeId
                });
            }

            return toSave.save()
                .always(_.bind(me.onSearchCompleted, me, model))
                .done(_.bind(me.onSearchSuccess, me, model))
                .fail(_.bind(me.onSearchFailed, me, model));
        },
        onSearchCompleted: function () {
            const me = this;
            me.clearDisabledState();
        },
        onSearchSuccess: function (model, data) {
            const me = this;
            const areCreatingLandscape = me.createLandscape;

            // NOTE: if we are adding companies to our landscape, and this is a
            // new landscape then create the landscape first
            if (areCreatingLandscape && !me.landscapeModel.id) {
                me.saveLandscape()
                    .done(function () {
                        me.doFollow(data.id, me.landscapeModel.id)
                            .always(function (xhr) {
                                let attributes = xhr.responseJSON;
                                // NOTE because upstream we use `then` on the
                                // request `responseJSON` will only exist on
                                // failure (when errors have occurred)
                                if (!attributes) {
                                    attributes = xhr.attributes;
                                }

                                // NOTE we must set the model attributes here
                                // with the second follow response in the event
                                // that an error occurred (as the first request
                                // merely adds the company to the system without
                                // following it in the active landscape)
                                model.set(attributes);
                            });
                    })
                    .fail(function () {
                        if (me.onError) {
                            me.onError('Something went wrong. Please reload your page and try again.');
                        }
                    });
            }

            me.onCompanyAdd(data);
            me.ui.domainInput.val?.('');
            me.hasAddedCompany = true;

            if (me.enableDoneButton) {
                me.enableDoneButton();
            }

            me.clearDisabledState();
            me.ui.domainInput.focus?.();

            App.trigger('landscape:company:added', data, !areCreatingLandscape);
        },
        onLandscapeCreated: _.noop,
        onSearchFailed: function (model, xhr) {
            let error;
            const me = this;

            if (xhr.status === 503) {
                error = {
                    RESTerror: {
                        name: 'Timeout'
                    }
                };
                me.ui.domainInput.val?.('');
                model.set(error);
            } else {
                try {
                    error = $.parseJSON(xhr.responseText);
                    model.set(error);
                } catch (e) {
                    // trigger the default error handler
                    model.set({
                        RESTerror: {}
                    });
                }

                me.ui.domainInput.val?.('');
            }

            me.clearDisabledState();
            me.enableDoneButton();
        },
        onSuggestionSelected: function (suggestion) {
            const me = this;
            me.ui.domainInput.val(suggestion);
            me.search();
        },
        onOverLimit: function () {
            // this can be overridden by derived classes
        },
        onCompanyAdd: function () {
            // this is a dummy function that can be overridden
        },
        onError: function () {
            // this is a dummy function that can be overridden
        },
        onCompanyRemoved: function (companyData) {
            // this is a dummy function that can be overridden
        }
    });

});
